



































































































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import Evaluation from '@/evaluations/entities/evaluation'

@Component
export default class EvaluationForm extends Vue {
  @Prop()
  private value!: Evaluation

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  private model = this.value

  private tab: any = null

  @Watch('value')
  private valueUpdated(val: Evaluation, old: Evaluation) {
    this.model = val
  }
}
